function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { BaseAuthHandler } from './base';
import { TOKEN_KEY, TOKEN_TYPE_KEY, USER_KEY, REFRESH_TOKEN_KEY, ACCESS_TOKEN_EXPIRES_AT_KEY } from '../types';
import { handleRefreshTokenFlow } from '../utils/refresh';
import { scheduleTokenRefresh, clearScheduledRefresh } from './web-utils';
import { performLogout } from './web-logout';
import { tokenManager } from '../token-manager';
export var WebAuthHandler = /*#__PURE__*/ function(BaseAuthHandler) {
    "use strict";
    _inherits(WebAuthHandler, BaseAuthHandler);
    function WebAuthHandler(authServerUrl) {
        _class_call_check(this, WebAuthHandler);
        return _call_super(this, WebAuthHandler, [
            authServerUrl
        ]);
    }
    _create_class(WebAuthHandler, [
        {
            key: "initialize",
            value: function initialize(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var storedToken, storedUserJson, storedRefreshToken, isAuthenticated, user, token, storedExpiresAt, tokenExpiryTime, now, refreshSuccess, updatedUserJson, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[WebAuthHandler] Initializing...');
                                clearScheduledRefresh();
                                storedToken = localStorage.getItem(TOKEN_KEY);
                                storedUserJson = localStorage.getItem(USER_KEY);
                                storedRefreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
                                isAuthenticated = false;
                                user = null;
                                token = storedToken;
                                if (!storedToken) return [
                                    3,
                                    8
                                ];
                                console.log('[WebAuthHandler] Found stored token. Verifying validity...');
                                if (storedUserJson) {
                                    try {
                                        user = JSON.parse(storedUserJson);
                                        console.log('[WebAuthHandler] Loaded user from localStorage:', user.username);
                                    } catch (e) {
                                        console.error('[WebAuthHandler] Failed to parse stored user:', e);
                                    }
                                }
                                storedExpiresAt = localStorage.getItem(ACCESS_TOKEN_EXPIRES_AT_KEY);
                                tokenExpiryTime = storedExpiresAt ? parseInt(storedExpiresAt, 10) : null;
                                now = Date.now();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                if (!(tokenExpiryTime && tokenExpiryTime > now)) return [
                                    3,
                                    2
                                ];
                                console.log('[WebAuthHandler] Token not yet expired. Setting authenticated state.');
                                isAuthenticated = true;
                                setState(function() {
                                    return {
                                        user: user,
                                        token: storedToken,
                                        isAuthenticated: true
                                    };
                                });
                                scheduleTokenRefresh(tokenExpiryTime, setState, _this);
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!storedRefreshToken) return [
                                    3,
                                    4
                                ];
                                console.log('[WebAuthHandler] Token expired or no expiry info. Attempting refresh...');
                                return [
                                    4,
                                    _this.handleTokenRefresh(setState)
                                ];
                            case 3:
                                refreshSuccess = _state.sent();
                                if (refreshSuccess) {
                                    isAuthenticated = true;
                                    token = localStorage.getItem(TOKEN_KEY);
                                    user = null;
                                    updatedUserJson = localStorage.getItem(USER_KEY);
                                    if (updatedUserJson) {
                                        try {
                                            user = JSON.parse(updatedUserJson);
                                        } catch (e) {
                                            console.error('[WebAuthHandler] Failed to parse updated user:', e);
                                        }
                                    }
                                } else {
                                    console.warn('[WebAuthHandler] Token refresh failed during initialization.');
                                    isAuthenticated = false;
                                    token = null;
                                    user = null;
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                console.warn('[WebAuthHandler] Token expired and no refresh token available.');
                                _this.handleSessionExpired(setState, 'missing_refresh_token');
                                isAuthenticated = false;
                                token = null;
                                user = null;
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                console.error('[WebAuthHandler] Error during initialization verification:', error);
                                _this.handleSessionExpired(setState, 'refresh_exception');
                                token = null;
                                user = null;
                                isAuthenticated = false;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                console.log('[WebAuthHandler] No token found in localStorage.');
                                setState(function() {
                                    return {
                                        user: null,
                                        token: null,
                                        isAuthenticated: false
                                    };
                                });
                                _state.label = 9;
                            case 9:
                                console.log("[WebAuthHandler] Initialization complete. isAuthenticated: ".concat(isAuthenticated));
                                return [
                                    2,
                                    {
                                        isAuthenticated: isAuthenticated,
                                        user: user,
                                        token: token
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkAuthStatus",
            value: function checkAuthStatus(setState) {
                return _async_to_generator(function() {
                    var storedToken, isAuthenticated;
                    return _ts_generator(this, function(_state) {
                        console.log('[WebAuthHandler] Checking auth status...');
                        storedToken = localStorage.getItem(TOKEN_KEY);
                        isAuthenticated = !!storedToken;
                        console.log("[WebAuthHandler] Token in localStorage: ".concat(isAuthenticated));
                        setState(function(current) {
                            return _object_spread_props(_object_spread({}, current), {
                                isAuthenticated: isAuthenticated,
                                token: storedToken
                            });
                        });
                        return [
                            2,
                            isAuthenticated
                        ];
                    });
                })();
            }
        },
        {
            key: "getCurrentUser",
            value: function getCurrentUser(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var token, storedUserJson, user, profileResponse, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[WebAuthHandler] Getting current user...');
                                token = localStorage.getItem(TOKEN_KEY);
                                storedUserJson = localStorage.getItem(USER_KEY);
                                if (!token) {
                                    console.log('[WebAuthHandler] No token found for getCurrentUser.');
                                    setState(function(current) {
                                        return _object_spread_props(_object_spread({}, current), {
                                            user: null,
                                            isAuthenticated: false,
                                            token: null
                                        });
                                    });
                                    return [
                                        2,
                                        {
                                            user: null,
                                            isAuthenticated: false
                                        }
                                    ];
                                }
                                user = null;
                                // Try to load user from localStorage
                                if (storedUserJson) {
                                    try {
                                        user = JSON.parse(storedUserJson);
                                        console.log('[WebAuthHandler] Loaded user from localStorage:', user.username);
                                    } catch (e) {
                                        console.error('[WebAuthHandler] Failed to parse stored user:', e);
                                    }
                                }
                                if (!(_this.apiService && (user === null || user === void 0 ? void 0 : user.username))) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.apiService.userApi.fetchUserProfileByUsernameUsingGET(user.username)
                                ];
                            case 2:
                                profileResponse = _state.sent();
                                if (profileResponse.data) {
                                    user = profileResponse.data;
                                    localStorage.setItem(USER_KEY, JSON.stringify(user));
                                    console.log('[WebAuthHandler] Fetched updated user profile:', user.username);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error('[WebAuthHandler] Failed to fetch updated user profile:', error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                // We have a token, but potentially no user data
                                if (user) {
                                    setState(function(current) {
                                        return _object_spread_props(_object_spread({}, current), {
                                            user: user,
                                            isAuthenticated: true,
                                            token: token
                                        });
                                    });
                                    return [
                                        2,
                                        {
                                            user: user,
                                            isAuthenticated: true
                                        }
                                    ];
                                }
                                // Fallback: if we have a token but no user data, consider partially authenticated
                                setState(function(current) {
                                    return _object_spread_props(_object_spread({}, current), {
                                        user: null,
                                        isAuthenticated: !!token,
                                        token: token
                                    });
                                });
                                return [
                                    2,
                                    {
                                        user: null,
                                        isAuthenticated: !!token
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleTokenRefresh",
            value: function handleTokenRefresh(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var refreshToken, existingTokenType, refreshResult, newExpiresAt, _refreshResult_tokenType, _refreshResult_refreshToken, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[WebAuthHandler] Attempting Refresh Token Flow...');
                                refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
                                existingTokenType = localStorage.getItem(TOKEN_TYPE_KEY) || 'Bearer';
                                if (!refreshToken) {
                                    console.warn('[WebAuthHandler] No refresh token found. Cannot perform refresh.');
                                    _this.handleSessionExpired(setState, 'missing_refresh_token');
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    handleRefreshTokenFlow(refreshToken, _this.authServerUrl, existingTokenType)
                                ];
                            case 2:
                                refreshResult = _state.sent();
                                if (!refreshResult.success || !refreshResult.accessToken) {
                                    console.error('[WebAuthHandler] Refresh token flow failed.', refreshResult.error);
                                    _this.handleSessionExpired(setState, refreshResult.error || 'refresh_failed');
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                console.log('[WebAuthHandler] Refresh Token Flow successful. Setting new token...');
                                console.log('[WebAuthHandler] Token type:', refreshResult.tokenType);
                                // Store new tokens
                                localStorage.setItem(TOKEN_KEY, refreshResult.accessToken);
                                if (refreshResult.tokenType) {
                                    localStorage.setItem(TOKEN_TYPE_KEY, refreshResult.tokenType);
                                }
                                if (refreshResult.refreshToken) {
                                    localStorage.setItem(REFRESH_TOKEN_KEY, refreshResult.refreshToken);
                                }
                                if (refreshResult.expiresIn) {
                                    newExpiresAt = Date.now() + refreshResult.expiresIn * 1000;
                                    localStorage.setItem(ACCESS_TOKEN_EXPIRES_AT_KEY, newExpiresAt.toString());
                                    scheduleTokenRefresh(newExpiresAt, setState, _this);
                                    tokenManager.setExpiresIn(refreshResult.expiresIn);
                                }
                                tokenManager.setToken(refreshResult.accessToken, (_refreshResult_tokenType = refreshResult.tokenType) !== null && _refreshResult_tokenType !== void 0 ? _refreshResult_tokenType : existingTokenType);
                                tokenManager.setRefreshToken((_refreshResult_refreshToken = refreshResult.refreshToken) !== null && _refreshResult_refreshToken !== void 0 ? _refreshResult_refreshToken : refreshToken);
                                if (refreshResult.tokenType) {
                                    tokenManager.setTokenType(refreshResult.tokenType);
                                }
                                // Update state
                                setState(function(current) {
                                    return _object_spread_props(_object_spread({}, current), {
                                        isAuthenticated: true,
                                        token: refreshResult.accessToken || null
                                    });
                                });
                                return [
                                    2,
                                    true
                                ];
                            case 3:
                                error = _state.sent();
                                console.error('[WebAuthHandler] Refresh Token Flow error:', error);
                                _this.handleSessionExpired(setState, 'refresh_error');
                                return [
                                    2,
                                    false
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: function logout(setState, idTokenHint) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    performLogout(setState, _this.authServerUrl, idTokenHint)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setAuthenticatedState",
            value: function setAuthenticatedState(user, token, refreshToken, expiresIn, setState) {
                var _this = this;
                var tokenType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 'Bearer', idToken = arguments.length > 6 ? arguments[6] : void 0;
                var _this1 = this, _superprop_get_setAuthenticatedState = function() {
                    return _get(_get_prototype_of(WebAuthHandler.prototype), "setAuthenticatedState", _this);
                };
                return _async_to_generator(function() {
                    var newExpiresAt;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_setAuthenticatedState().call(_this1, user, token, refreshToken, expiresIn, setState, tokenType, idToken)
                                ];
                            case 1:
                                _state.sent();
                                if (expiresIn) {
                                    newExpiresAt = Date.now() + expiresIn * 1000;
                                    scheduleTokenRefresh(newExpiresAt, setState, _this1);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleSessionExpired",
            value: function handleSessionExpired(setState) {
                var reason = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'session_expired';
                console.warn("[WebAuthHandler] Session expired (".concat(reason, "). Clearing auth state."));
                clearScheduledRefresh();
                this.clearAuthStorage();
                if (typeof window !== 'undefined') {
                    try {
                        window.dispatchEvent(new CustomEvent('auth:session-expired', {
                            detail: {
                                reason: reason
                            }
                        }));
                    } catch (eventError) {
                        console.warn('[WebAuthHandler] Failed to dispatch session-expired event:', eventError);
                    }
                    try {
                        var _window_sessionStorage;
                        (_window_sessionStorage = window.sessionStorage) === null || _window_sessionStorage === void 0 ? void 0 : _window_sessionStorage.setItem('auth:session_expired', reason);
                    } catch (storageError) {
                        console.warn('[WebAuthHandler] Failed to persist session-expired flag:', storageError);
                    }
                }
                setState(function() {
                    return {
                        user: null,
                        token: null,
                        isAuthenticated: false
                    };
                });
            }
        }
    ]);
    return WebAuthHandler;
}(BaseAuthHandler);
